import React from "react";
import pul29Image from "../assets/images/menu/pu-l29.png";

export const pul29Configuration = {
  // Page header configuration
  pageTitle: "LEXORA | PU-L29",
  breadcrumbs: [{ label: "PU-L29", link: null }],
  // Product details
  productName: "LEXORA | PU-L29",
  productSubtitle:
    "Highly Flexible, Two-Component Polyurethane Adhesive for Diverse Surfaces Like Metal, Plywood & Drywalls",
  productImage: pul29Image,
  description:
    "LEXORA PU-L29 is a high-performance, two-component polyurethane thinset adhesive designed for superior bonding of tiles and stone on both interior and exterior floors and walls. Engineered for exceptional flexibility, it is ideal for a wide range of substrates, including metal, plywood, and drywall. This multipurpose adhesive ensures strong and durable adhesion, making it the perfect solution for challenging installations.",
  tdsLink: "/assets/tds/pu-l29.pdf",
  dealerLink: "/where-to-buy",
  altText: "PU-L29 Epoxy Based Liquid Adhesive",

  // Accordion items for product features
  accordionItems: [
    {
      title: "Standard Compliance/specification",
      content: (
        <div>
          <ul className="space-y-4">
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Complies to Type 5 'T S2' as per IS 15477: 2019 - Adhesives for
                use with ceramic, mosaic and stone tiles - Specification.
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Classified as R2T per EN 12004/ISO 13007: reaction resin
                adhesive (R), improved (2), slip-resistant (T).
              </p>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Area of Use",
      content: (
        <div>
          <div className="space-y-4">
            <p className="product-details__description__text text-gray-700">
              For all exterior tile/stone fixing & drywall tile installation,
              consult with LEXORA Technical Team.
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Features and Advantages",
      content: (
        <div>
          <ul className="space-y-4">
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Two components; just mix and use</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Long open time – suitable for large format & external conditions
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Water, freezing, thermal shock resistant</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Sustains heat aging – ideal for external & high-temperature
                applications
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Highly flexible – sustains heavy vibrations</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Chemical resistant – resists solvents, alkalis & oils</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Suitable for glass, metals, drywalls, plywoods</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Compatible with all tiles/stones including composites,
                artificial stones, metal & glass tiles
              </p>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Application Substrates",
      content: (
        <div>
          <div className="space-y-4">
            <h5 className="font-semibold text-kajaria-brown-900">
              Material to be fixed
            </h5>
            <p className="product-details__description__text text-gray-700">
              All types of tiles, glass mosaic, large format tiles, precast
              terrazzo, all-natural stones, large thin/slim tiles,
              composites/artificial/nano/engineered stones, metal & glass tiles.
            </p>
            <h5 className="font-semibold text-kajaria-brown-900">
              On surface/substrate
            </h5>
            <p className="product-details__description__text text-gray-700">
              Cement-based (screeds, plaster, concrete), metals (iron, steel,
              copper, aluminum), Epoxy/PU substrates, drywall
              (gypsum/bison/fibre/cement board), existing tiles & stones,
              plywood, MDF, rubber, PVC, glass, etc.
            </p>
            <h5 className="font-semibold text-kajaria-brown-900">
              Area of application
            </h5>
            <p className="product-details__description__text text-gray-700">
              Floor and walls, internal & external areas, window/door frames,
              vibrational areas, kitchens, balconies, flat roofs, domes,
              terraces, domestic, commercial & industrial applications
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Limitations",
      content: (
        <div>
          <ul className="space-y-4">
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Not for contact with polystyrene or uncured/moisture-laden
                substrates
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>Not suitable for transparent glass materials</p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                Not a replacement for waterproofing – use prior waterproof
                coating for wet areas
              </p>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Technical Information | Application Properties",
      content: (
        <div>
          <ul className="space-y-4">
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <div>
                <p>
                  <strong>Component Appearance:</strong>
                </p>
                <ul className="ml-6 mt-2 space-y-1">
                  <li>
                    <b>Part A (Base):</b> White Paste
                  </li>
                  <li>
                    <b>Part B (Hardener):</b> Liquid
                  </li>
                </ul>
              </div>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <strong>Mixing Ratio:</strong> Part A-3.650 kg & Part B-0.350 kg
                (100:10 by weight)
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Mixed Appearance:</b> Off White Paste
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Mixed Density:</b> 1.65 ± 0.1 kg/litre
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Open Time / Adjustability / Pot Life:</b> Min. 60 minutes
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Sag/Slip:</b> ≤0.5mm
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Application Temperature:</b> 10°C to 40°C
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Temp Resistance:</b> -40°C to +100°C
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Setting/Trafficable/Grouting Time:</b> 24 hours
              </p>
            </li>
            <li className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-5 h-5 bg-kajaria-blue-600 rounded-full flex items-center justify-center mt-1">
                <span className="text-white text-xs">✓</span>
              </span>
              <p>
                <b>Normal Use Interval:</b> 3 days (7 days for heavy-duty
                traffic)
              </p>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Packaging",
      content: (
        <div>
          <p><strong>Packaging :</strong> Part - A 3200gm + Part - B 800gm</p>
        </div>
      ),
    }
  ],

  // Installation tabs
  installationTabs: [
    {
      label: "Surface Preparation",
      content: [
        "The substrate must be levelled, cured, undamaged, compact, rigid, resistant, dry and free from any debonding agents and from damp rising.",
        "All surfaces must be plumb and true to within 6 mm in 10 ft (3m).",
        "Dry, dusty surfaces should be dampened with water & excess water should be swept off.",
        "New concrete slabs shall be damp cured and 28 days old before application which will reduce the shrinkage from tile fixing surface.",
        "Rust on iron surfaces must be removed by sandblasting.",
        "Expansion joints are to be provided & filled with suitable sealant.",
        "Don't cover expansion joints with thin set tile adhesive/tile.",
      ],
    },
    {
      label: "Mixing",
      content: [
        "The two components of LEXORA PU-L29 are supplied in ready-to-mix bucket.",
        "Pour the part B into part A and mix well until a uniform white paste is obtained.",
        "Mix with a suitable mechanical stirrer or slow-speed drills (50-100 rpm) until a lump-free homogeneous paste is obtained.",
        "Always mix the required quantity, which can be consumed within pot life.",
        "Leave the mixture for 5 minutes before use.",
        "The ratio of the part A and part B is fixed, and any modification and/or inappropriate ratio could cause incorrect hardening of the product.",
      ],
    },
    {
      label: "Application",
      content: [
        "Apply adhesive to the substrate with the flat side of the trowel.",
        "Comb on additional adhesive with the notched side.",
        "Use the proper sized notched trowel to ensure full bedding of the tile.",
        "Tiles must be fixed within 60 minutes of adhesive being applied, depending on atmospheric conditions.",
        "Check the adhesive ribs periodically and if a skin has formed, remove the dried adhesive and apply fresh adhesive.",
        "Press the tiles firmly into position with a slight twisting action, checking periodically that good contact is maintained with the back of each tile and beat in using a rubber mallet to embed tile and adjust level.",
        "Leave no voids behind tiles.",
        "For large size tiles or irregular surfaces, adhesive can additionally be buttered on the backs of the tiles to ensure full adhesive contact.",
        "Use suitable support along with adhesive for fixing tiles on vertical surfaces.",
        "Leave adequate joints between individual wall and floor tiles using LEXORA spacers.",
        "The joint width shall be as per the recommendation of the architect/engineer. Provide joints (spaces) on the periphery of the area without allowing the tile/stone to be bound by the peripheral area.",
        "Fill the resulting grout joints with flexible materials like LEXORA epoxy range/suitable silicon or acrylic sealants.",
        "Clean off surplus adhesive from the tile face and between joints.",
        "Clean tools and tile work with water or suitable solvent while adhesive is fresh. Once cured, the adhesive can only be removed by mechanical means.",
      ],
    },
    {
      label: "Precautions & Notes",
      content: [
        "Avoid damp surfaces",
        "Do not modify ratios",
        "Protect from rain and traffic for 12 hours",
        "For heights >3m, use mechanical fasteners for extra safety",
        "Leave gap around tiles and fill with appropriate grout",
      ],
    },
  ],

  // Working Properties - ISO Standards
  workingPropertiesISO: [
    {
      test: "Initial shear adhesion strength",
      requirement: "≥2.0 N/mm²",
      result: "≥5.0 N/mm²",
    },
    {
      test: "Shear adhesion strength after water immersion",
      requirement: "≥2.0 N/mm²",
      result: "≥5.0 N/mm²",
    },
    {
      test: "Shear adhesion strength after thermal shock",
      requirement: "≥2.0 N/mm²",
      result: "≥5.0 N/mm²",
    },
    {
      test: "Tensile adhesion - Open time (at 60 minutes)",
      requirement: "≥1.0 N/mm²",
      result: "≥1.5 N/mm²",
    },
    { test: "Slip resistance (T)", requirement: "≤0.5 mm", result: "≤0.3 mm" },
  ],

  // Working Properties - IS Standards
  workingPropertiesIS: [
    {
      test: "Tensile (dry, 28 days)",
      requirement: "≥2.0 N/mm²",
      result: "≥2.5 N/mm²",
    },
    { test: "Tensile (wet)", requirement: "–", result: "≥1.5 N/mm²" },
    { test: "Shear (dry)", requirement: "≥6.0 N/mm²", result: "≥7.0 N/mm²" },
    { test: "Shear (wet)", requirement: "–", result: "≥6.0 N/mm²" },
    {
      test: "Shear (heat aging)",
      requirement: "≥3.0 N/mm²",
      result: "≥6.0 N/mm²",
    },
    { test: "Deformability (S2)", requirement: "≥5mm", result: "≥30mm" },
  ],

  // Technical note
  technicalNote:
    "Test results are indicative as per testing method specified in standard. Test results may vary as per substrate, site condition & testing machine etc. Actual field performance will depend on installation methods and site conditions.",

  // Precautions and Notes
  precautionsAndNotes: [
    "Do not use on damp surfaces or where there is a risk of rising damp.",
    "The packs are pre-measured, therefore mixing errors are impossible. For partial mixing, weigh the two parts precisely.",
    "Any modification and/or inappropriate ratio could cause incorrect hardening of the product.",
    "Protect against direct rain/foot traffic for at least 12 hours.",
    "Tiles/stones should not be installed directly on expansion joints.",
    "Leave a gap between the tile & fill gaps with LEXORA tile grout.",
    "The designer/applicator must evaluate the use of an additional mechanical fastening system for extra security for more than 3 m height (such as steel hooks fastened to the substrate).",
  ],

  // Coverage
  coverage: [
    "16–20 sq. ft/4 kg pack – 1.5 mm bed thickness (3 mm x 3 mm notch)",
    "8–10 sq. ft/4 kg pack – 3 mm bed thickness (6 mm x 6 mm notch)",
    "Coverage will vary depending on trowel notch size, type, size of tile and substrate smoothness and evenness.",
  ],

  // Packaging
  packaging: "4 kg bucket",

  // Shelf Life
  shelfLife:
    "24 months (sealed pack, stored dry, shaded, temperature-protected)",

  // Grouting
  grouting:
    "After 24 hours of tiling using LEXORA cementitious or epoxy grouts.",

  // Safety Precautions
  safetyPrecautions: [
    "Keep away from children",
    "Use gloves, eye and face protection",
    "Wash immediately with water upon contact",
    "For eyes: rinse and seek medical advice",
    "Professional use only",
    "Refer MSDS for full safety info",
  ],

  // Disclaimer
  disclaimer:
    "While the company guarantees its products against defective materials, the use and application of these products are made without guarantee since the conditions of their application are beyond its control. It is recommended to verify with the company that the product is suitable for the intended use, and that this Data Sheet version is the latest one. The company may modify it without prior notice. Technical characteristics are listed for guidance only. For more information, please contact the company office in your location.",
};
